module.exports = __webpack_public_path__ + "img/educator-k-4.002b13d4.png";